class ReserveTable extends HTMLElement {
  constructor() {
    super();

    const thisElement = this;

    let select = this.querySelector('select');
    let button = this.querySelector('button');

    select.addEventListener('change', function () {
      let venue = select.value;

      if (venue != '') {
        thisElement.updateBtn(button, venue);
      }

    });
  }

  updateBtn(btn, venue) {
    btn.dataset.venue = venue;
    this.initialiseSevenRooms(venue, btn);
  }


  initialiseSevenRooms(venue, btn) {
    SevenroomsWidget.init({
      venueId: venue,
      triggerId: btn.id,
      type: 'reservations',
      allVenues: window.restaurants.restaurant_ids
    });
  }
}

customElements.define("reserve-table", ReserveTable);